var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainagnostic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 74,
    viewBox: "0 0 84 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 37L26 9",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37L2 27",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 54L56.3237 16.9781L78 12",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62 49.7875L34 37L37.7617 67",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 43C37.3137 43 40 40.3137 40 37C40 33.6863 37.3137 31 34 31C30.6863 31 28 33.6863 28 37C28 40.3137 30.6863 43 34 43Z",
    fill: "#DD44B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16C81.2091 16 83 14.2091 83 12C83 9.79086 81.2091 8 79 8C76.7909 8 75 9.79086 75 12C75 14.2091 76.7909 16 79 16Z",
    fill: "white",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 43C37.3137 43 40 40.3137 40 37C40 33.6863 37.3137 31 34 31C30.6863 31 28 33.6863 28 37C28 40.3137 30.6863 43 34 43Z",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 10C27.2091 10 29 8.20914 29 6C29 3.79086 27.2091 2 25 2C22.7909 2 21 3.79086 21 6C21 8.20914 22.7909 10 25 10Z",
    fill: "white",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 61C13.2091 61 15 59.2091 15 57C15 54.7909 13.2091 53 11 53C8.79086 53 7 54.7909 7 57C7 59.2091 8.79086 61 11 61Z",
    fill: "white",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38 72C40.2091 72 42 70.2091 42 68C42 65.7909 40.2091 64 38 64C35.7909 64 34 65.7909 34 68C34 70.2091 35.7909 72 38 72Z",
    fill: "white",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5 32C7.20914 32 9 30.2091 9 28C9 25.7909 7.20914 24 5 24C2.79086 24 1 25.7909 1 28C1 30.2091 2.79086 32 5 32Z",
    fill: "white",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53C64.2091 53 66 51.2091 66 49C66 46.7909 64.2091 45 62 45C59.7909 45 58 46.7909 58 49C58 51.2091 59.7909 53 62 53Z",
    fill: "white",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21C59.2091 21 61 19.2091 61 17C61 14.7909 59.2091 13 57 13C54.7909 13 53 14.7909 53 17C53 19.2091 54.7909 21 57 21Z",
    fill: "white",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainagnostic);
export default __webpack_public_path__ + "static/media/chainagnostic.2c60456ac0e649ec2a7cf7e08565fc9e.svg";
export { ForwardRef as ReactComponent };